import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';
import { Label } from '@/components/atoms/texts/label';
import useOnboardingCandidate from '@/services/admin-services/query/useOnboardingCandidate';

const BreadcrumbCandidateDetails = () => {
    const navigate = useNavigate();
    const { candidateUuid } = useParams();
    const [t] = useTranslation('global');
    const { data: candidate, loading } = useOnboardingCandidate(candidateUuid);

    const candidateName = candidate ? `${candidate.firstname} ${candidate.lastname}`.trim() : 'Candidat';

    return (
        <div className="flex items-center gap-1">
            <button
                type="button"
                onClick={() => navigate('/management/onboarding')}
                className="inline-flex items-center gap-1 text-primary hover:underline transition-colors"
            >
                <Label className="text-sm font-medium cursor-pointer">{t('management.onboarding.actions.onboardingList')}</Label>
            </button>
            <ChevronRight className="h-4 w-4 text-greyStrong" />
            <Label className="text-sm font-medium text-night">
                {candidateName}
            </Label>
        </div>
    );
};

export default BreadcrumbCandidateDetails;
